import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useScopes } from '../../../../hooks/useScope';
import { resolveAccessibleDestination } from '../../../../utils/resolveAccessiblePath';

function NoPermissionFallback() {
    const navigate = useNavigate();
    const scopes = useScopes();
    const { path, label } = resolveAccessibleDestination(scopes);

    return (
        <Result
            status="403"
            title="Access Denied"
            subTitle="You do not have permission to access this page."
            extra={
                <Button type="primary" onClick={() => navigate(path)}>
                    Go to {label}
                </Button>
            }
        />
    );
}

export default NoPermissionFallback;
